export enum AssetStatus {
  IN_PROGRESS = "IN_PROGRESS",
  WAITING = "WAITING",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export enum AssetRequestType {
  UPLOAD = "UPLOAD",
  DOWNLOAD = "DOWNLOAD",
}
